/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetCurrentUserQuery } from '../../models/get-current-user-query';
import { UserDtoApiResponse } from '../../models/user-dto-api-response';

export interface GetCurrentUserAsync$Params {
  query?: GetCurrentUserQuery;
}

export function getCurrentUserAsync(http: HttpClient, rootUrl: string, params?: GetCurrentUserAsync$Params, context?: HttpContext): Observable<StrictHttpResponse<UserDtoApiResponse>> {
  const rb = new RequestBuilder(rootUrl, getCurrentUserAsync.PATH, 'get');
  if (params) {
    rb.query('query', params.query, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserDtoApiResponse>;
    })
  );
}

getCurrentUserAsync.PATH = '/api/user/current';
